import { CoreLib_Classes_Guid } from 'core';
import { ICrudEntity } from '../interfaces/ICrudEntity';


export class CrudEntityNew implements ICrudEntity {
  uid: string = CoreLib_Classes_Guid.Empty;  
}
